import md5 from 'md5';
import axios from "axios";
import qs from "qs";
import { v4 as uuidv4 } from "uuid";
import { message } from 'antd';

// async function getSecretKey() {
//   let token = localStorage.getItem('token');
//   const res = await axios({
//     method: 'GET',
//     url: `${process.env.REACT_APP_API_OPEN_SERVER}/v1/affiliate/portal/auth/secret-key`,
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `bearer ${token}`,
//     },
//   });
//   return res;
// }

async function getSecretKey() {
  const token = localStorage.getItem('token');
  try {
    const res = await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_OPEN_SERVER}/v1/affiliate/portal/auth/secret-key`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return res; // hoặc return res.data nếu bạn chỉ cần dữ liệu
  } catch (error) {
    if (error.response?.status === 401) {
      message.error('Phiên đăng nhập của bạn đã hết hạn.');
      setTimeout(() => {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }, 3000);
    }
  }
}

const sortObjectByKey = (obj) => {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObject = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });
  return sortedObject;
};

async function openApiCall(method, url, dataForm) {
  const token = localStorage.getItem('token');
  const queryParams = Object.entries(dataForm || {})
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  const secretKey = await getSecretKey();
  if (secretKey.data.success) {
    const env = process.env.REACT_APP_APP_NODE;
    const data = qs.stringify(sortObjectByKey(dataForm || {}));
    const uuid = uuidv4();
    const client = md5(env + "-" + data + secretKey?.data?.data?.stime + uuid + secretKey?.data?.data?.secretKey);
    const header = {
      "x-api-stime": secretKey?.data?.data?.stime,
      "x-api-nonce": uuid,
      "x-api-client": client,
    }
    const res = await axios({
      method: method,
      url: `${process.env.REACT_APP_API_OPEN_SERVER}${url}${(queryParams && method === 'GET') ? `?${queryParams}` : ""}`,
      data: dataForm,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...header
      },
    });
    return res
  }
}


async function openApiCalltest(method, url, dataForm) {
  const token = 'eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxIiwic3ViIjoiMzIxZDIzOTYtY2I5Yy00OGRhLWEwY2QtMjgxYmE1NDI2MTk5IiwiaWF0IjoxNzUyMzk4NTYwLCJleHAiOjE3NTI0ODQ5NjB9.NQWUz5y5QYq6rZeJQNQHlZnib5COLCNd5kg1-YDQ8Ds02uB80XqYmyLJDgK6uCyK0K-6z9frXs09OEaL7w9sBPOvdrLJOJCh2o5rNAwhac5U9geMMg-ZLr0M4POiye2Z-vDy1VxWho1gPh87jDI1_nWXOpO4wvZl7lgPU4w5P_wHxc48eVSriUQA0rkvz6daHKYUgUjCyL7VxmjuRxD4pnOQFOwSo7JV4CS17cYe8kZs0aaPWJaBorYG1WCpyF3J2V0B2ll9iczUE0lB57T_xTfQ515gs6uIylVE2HTRke4HAIkzZlzvoFcOdAuM_RCFnHyyIynf4KXM1SrEpPcqvQ';
  const res = await axios({
    method: 'GET',
    url: `${'https://open-api.globalcare.vn/'}${url}`,
    data: {},
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res
}

export default {
  openApiCall, openApiCalltest
};
